import { DEFAULT_LANGUAGE } from 'constants/localization';
import { DEVICE_OS } from 'constants/values';

const AVAILABLE_LANGUAGES: Record<string, string> = {
    en: 'en-us',
    fr: 'fr-fr',
    de: 'de-de',
    it: 'it-it',
    es: 'es-es',
    pt: 'pt-br',
};

const BASE_LINK = 'https://help-centre.walkfit.welltech.com/';

export const getFaqLink = (language: string, deviceOs: string) => {
    const languageCode = AVAILABLE_LANGUAGES[language] || AVAILABLE_LANGUAGES[DEFAULT_LANGUAGE];
    const isMobileDevice = deviceOs === DEVICE_OS.ANDROID || deviceOs === DEVICE_OS.IOS;

    if (isMobileDevice) {
        return `${BASE_LINK}/${languageCode}?device=${deviceOs.toLowerCase()}`;
    }

    return `${BASE_LINK}${languageCode}`;
};
